import {AsyncInlineError, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

import {DomainSharedError} from '../../shared/Errors/DomainSharedError.js'
import {VehicleSuggesterTrackingDataValueObject} from '../ValueObjects/VehicleSuggesterTrackingDataValueObject.js'

class GetVehicleSuggesterEventTrackingDataUseCase extends UseCase {
  static create() {
    return new GetVehicleSuggesterEventTrackingDataUseCase()
  }

  @tracer({metric: 'GetVehicleSuggesterEventTrackingDataUseCase#execute'})
  @AsyncInlineError()
  async execute({action, pageName, selectedOption}) {
    try {
      const vehicleSuggesterTrackingDataValueObject = VehicleSuggesterTrackingDataValueObject.createFromAction({
        action,
        pageName,
        selectedOption
      })

      return vehicleSuggesterTrackingDataValueObject
    } catch (error) {
      return Promise.reject(DomainSharedError.createGenericError({cause: error}))
    }
  }
}

export const factory = GetVehicleSuggesterEventTrackingDataUseCase.create
